import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';

import { PlayerState } from '../../../../types/state';
import { leaveTeam } from '../../../../services/teams';

export const Member: React.FC<{
  player: PlayerState;
  setSelectedPlayer: React.Dispatch<
    React.SetStateAction<PlayerState | undefined>
  >;
  setShowTeamList: React.Dispatch<React.SetStateAction<boolean>>;
  setShowPlayerChat: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ player, setSelectedPlayer, setShowPlayerChat, setShowTeamList }) => {
  const { gameCode } = useParams();
  const [isLoading, setIsLoading] = React.useState(false);

  const RemovePlayerOnTeamHandler = async (
    leaveTeamCode: string,
    playerCode: string
  ) => {
    try {
      setIsLoading(true);
      await leaveTeam(leaveTeamCode, playerCode, gameCode ?? '');
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <div className={'d-flex justify-content-between align-items-center mb-2'}>
      <div
        className={
          'd-flex justify-content-between w-100 align-items-center p-2 box-default-color'
        }>
        <div className={'d-flex align-items-center'}>
          <img
            width={30}
            height={30}
            src={player.avatarImage}
            className={'rounded-circle'}
            alt={player.name}
          />
          <div className={'ml-2'}>
            <strong>{player.name}</strong>
          </div>
        </div>
        <div className={'text-primary justify-self-end'}>
          <strong>{player.score}</strong>
        </div>
      </div>
      <div className={'d-flex align-items-center ml-2'}>
        <Button
          disabled={isLoading}
          className={'facilitator-button-light'}
          onClick={() => {
            setSelectedPlayer(player);
            setShowTeamList(true);
          }}>
          Change team
        </Button>
        <Button
          disabled={isLoading}
          className={'facilitator-button-light mx-2'}
          onClick={() => {
            RemovePlayerOnTeamHandler(player.teamCode ?? '', player.code ?? '');
          }}>
          <span>Remove player</span>
        </Button>
        <Button
          disabled={isLoading}
          themeColor={'primary'}
          onClick={() => {
            setSelectedPlayer(player);
            setShowPlayerChat(true);
          }}>
          Chat
        </Button>
      </div>
    </div>
  );
};
